<template>
  <div class="px-24">
    <!-- <div class="wrapper"> -->
      <t-row
        v-for="(item, i_index) in attr_info"
        :key="i_index"
        :title="item.text"
        titleClass="roleinfo-attr-gj-label2 justify-label"
        valueClass="roleinfo-attr-gj-value1 row-value-bg"
        :value="item.value"
      />
    <!-- </div> -->
  </div>
</template>
  
<script setup>
import { defineProps, ref, computed } from 'vue';

const props = defineProps({
  role_data: {
    type: Object,
    default: () => ({}),
  },
});

const new_attributes = computed(() => {
  return props.role_data?.new_attributes || {};
});

const new_role = computed(() => {
  return props.role_data?.new_role || {};
});

const ranks = computed(() => {
  return props.role_data?.ranks || {};
});

const attr_info = computed(() => {
  return [
    { text: '人物修为', value: new_role.value['xiuwei'] },
    {
      text: '全服排名',
      value: ranks.value['xiuwei'] ? ranks.value['xiuwei'][''] : '没有上榜',
    },
    {
      text: '本服排名',
      value: ranks.value['xiuwei']
        ? ranks.value['xiuwei']['server']
        : '没有上榜',
    },
    {
      text: '门派排名',
      value: ranks.value['xiuwei']
        ? ranks.value['xiuwei']['school']
        : '没有上榜',
    },
    // { text: '神启阶段', value: new_role.value['flySoulPhaseCN'] },
    // { text: '神启境界', value: new_role.value['flySoulLvCN'] },
    // { text: '启慧等级', value: new_attributes.value['pve_lv'] },
    // { text: '天灵点数', value: new_attributes.value['pve_talent_point'] },
    // { text: '风华值', value: new_role.value['fenghua'] },
  ];
});
</script>
